module.exports = __webpack_public_path__ + "img/s2.9f7c350b.png";